---
title: "ข้อกำหนดและเงื่อนไข"
path: "/th/ข้อกำหนดและเงื่อนไข"
seoTitle: "ข้อกำหนดและเงื่อนไข | Dutch Passion ประเทศไทย"
seoDescription: "ข้อกำหนดและเงื่อนไขเกี่ยวกับการสั่งซื้อ การชำระเงิน การจัดส่ง และการคืนสินค้า สำหรับการซื้อเมล็ดพันธุ์กัญชา Dutch Passion ในประเทศไทย กรุณาอ่านก่อนสั่งซื้อ"
---

ดัชนี:

มาตรา 1 – คำจำกัดความ

บทความที่ 2 – ตัวตนของผู้ประกอบการ

มาตรา 3 – การบังคับใช้

ข้อ 4 – ข้อเสนอ

มาตรา 5 – สัญญา

มาตรา 6 สิทธิในการถอนตัว

มาตรา 7 หน้าที่ของผู้บริโภคในระหว่างการพิจารณา

มาตรา 8 การใช้สิทธิถอนตัวของผู้บริโภคและค่าใช้จ่าย

มาตรา 9 ภาระผูกพันของผู้ประกอบการในกรณีถอนเงิน

มาตรา 10 การยกเว้นสิทธิในการถอนตัว

มาตรา 11 – ราคา

บทความที่ 12 – การปฏิบัติตามและการขยายการรับประกัน

มาตรา 13 การส่งมอบและการดำเนินการ

มาตรา 14 การทำธุรกรรมระยะเวลาขยาย: ระยะเวลา การยุติ และการต่ออายุ

มาตรา 15 – การชำระเงิน

มาตรา 16 การร้องเรียน

มาตรา 17 – ข้อพิพาท

บทความที่ 18 – นโยบายการจัดส่ง

 บทความที่ 19 – นโยบายการยกเลิก

 บทความที่ 20 – นโยบายการคืนสินค้าและการคืนเงิน

 ข้อ 21 – ข้อกำหนดเพิ่มเติมหรือแตกต่างกัน

มาตรา 1 – คำจำกัดความ

ภายใต้เงื่อนไขเหล่านี้ใช้:

- ข้อตกลงเพิ่มเติม: ข้อตกลง ซึ่งสินค้าอุปโภคบริโภค เนื้อหาดิจิทัล และ/หรือ บริการที่ได้รับจากสัญญาระยะไกล และสินค้า เนื้อหาดิจิทัล และ/หรือ บริการเหล่านี้ได้รับการจัดทำโดยผู้ค้าหรือบุคคลที่สามตามข้อตกลงระหว่างบุคคลที่สามนั้นและผู้ค้า
- ระยะเวลาผ่อนผัน: ระยะเวลาที่ผู้บริโภคสามารถใช้สิทธิในการถอนตัวได้
- ผู้บริโภค: บุคคลธรรมดาที่กระทำการเพื่อวัตถุประสงค์ที่เกี่ยวข้องกับการค้า ธุรกิจ หัตถกรรม หรืออาชีพของตน
- วัน: ปฏิทิน;
- เนื้อหาดิจิทัล หมายถึง ข้อมูลที่ผลิตและจัดทำในรูปแบบดิจิทัล
- ข้อตกลงระยะเวลา: ข้อตกลงที่ขยายไปจนถึงการส่งมอบสินค้า บริการ และ/หรือเนื้อหาดิจิทัลเป็นประจำเป็นระยะเวลาหนึ่ง
- สื่อที่คงทน: อุปกรณ์ใดๆ – รวมถึงอีเมลด้วย – ที่ผู้บริโภคหรือธุรกิจที่ทำให้สามารถส่งข้อมูลที่ส่งถึงตนเองโดยตรง จัดเก็บในลักษณะที่สามารถตรวจสอบได้หรือใช้ในอนาคตได้ในระยะเวลาที่เหมาะสมกับเป้าหมายที่ตั้งใจไว้ และซึ่งอนุญาตให้ทำซ้ำข้อมูลที่จัดเก็บไว้ได้โดยไม่เปลี่ยนแปลง
- สิทธิในการถอนตัว: ความสามารถของผู้บริโภคในการเห็นภายในระยะเวลารอคอยของสัญญา
- ผู้ประกอบการ: ผลิตภัณฑ์จากธรรมชาติ หรือถูกกฎหมายที่เสนอ (การเข้าถึง) เนื้อหาดิจิทัลและ/หรือบริการให้กับผู้บริโภค
- สัญญาทางไกล หมายถึง ข้อตกลงระหว่างผู้ประกอบการกับผู้บริโภคที่ทำขึ้นภายใต้กรอบระบบการขายทางไกลของผลิตภัณฑ์ เนื้อหาดิจิทัล และ/หรือ บริการ รวมถึงการสรุปข้อตกลงที่ใช้เฉพาะหรือบางส่วนของวิธีการสื่อสารทางไกลหนึ่งวิธีขึ้นไป
- แบบฟอร์มการถอนตัวแบบจำลอง: แบบฟอร์มมาตรฐานยุโรปในภาคผนวก I ของเงื่อนไขการถอนตัวเหล่านี้
- เทคโนโลยีเพื่อการสื่อสารระยะไกล: หมายถึง เทคโนโลยีที่ใช้ในการสรุปสัญญาโดยที่ผู้บริโภคและผู้ค้าไม่จำเป็นต้องพบกันในพื้นที่เดียวกันในเวลาเดียวกัน

บทความที่ 2 – ตัวตนของผู้ประกอบการ

ดัตช์ แพชชั่น ไทยแลนด์

อีเมล์ : info@dutchpassion.co.th

มาตรา 3 – การบังคับใช้

- เงื่อนไขทั่วไปเหล่านี้ใช้กับข้อเสนอทุกประการของผู้ประกอบการและข้อตกลงใดๆ ที่บรรลุโดยระยะไกลระหว่างธุรกิจและผู้บริโภค
- ก่อนจะสรุปสัญญาทางไกล ข้อความของเงื่อนไขทั่วไปเหล่านี้จะต้องให้ผู้บริโภคทราบ หากไม่สามารถดำเนินการได้โดยสมเหตุสมผล ผู้ประกอบการจะระบุเงื่อนไขทั่วไปสำหรับการตรวจสอบที่สถานที่ของผู้ประกอบการก่อนทำการสรุปสัญญาระยะไกล และส่งให้โดยไม่เสียค่าใช้จ่ายโดยเร็วที่สุดตามคำขอของผู้บริโภค
- หากทำสัญญาระยะไกลโดยวิธีอิเล็กทรอนิกส์ โดยไม่คำนึงถึงวรรคก่อนหน้า และก่อนที่จะทำสัญญาระยะไกล ข้อความของข้อกำหนดและเงื่อนไขเหล่านี้จะต้องพร้อมให้ผู้บริโภคเข้าถึงได้ทางอิเล็กทรอนิกส์ในลักษณะที่ผู้บริโภคสามารถจัดเก็บในสื่อที่ทนทานได้โดยง่าย หากไม่สามารถทำได้อย่างสมเหตุสมผล ก่อนที่จะปิดสัญญาระยะไกล เราจะแจ้งให้ทราบถึงเงื่อนไขทั่วไปทางอิเล็กทรอนิกส์ และจะส่งข้อมูลดังกล่าวไปให้ผู้บริโภคโดยไม่มีค่าใช้จ่ายทางอิเล็กทรอนิกส์หรือช่องทางอื่นๆ ตามคำขอของผู้บริโภค
- ในกรณีที่นอกเหนือไปจากเงื่อนไขทั่วไปเหล่านี้แล้ว ยังมีเงื่อนไขเฉพาะของผลิตภัณฑ์หรือบริการที่ใช้บังคับด้วย วรรคที่สองและสามจะต้องใช้บังคับ และในกรณีที่มีเงื่อนไขขัดแย้งกัน ผู้บริโภคจะต้องพึ่งพาบทบัญญัติที่ใช้บังคับซึ่งเป็นประโยชน์ต่อตนเองมากที่สุดเสมอ

ข้อ 4 – ข้อเสนอ

- หากข้อเสนอมีระยะเวลาจำกัดหรือมีเงื่อนไข เราจะระบุไว้ชัดเจนในข้อเสนอ
- ข้อเสนอประกอบด้วยคำอธิบายที่สมบูรณ์และถูกต้องเกี่ยวกับผลิตภัณฑ์ เนื้อหาดิจิทัล และ/หรือบริการที่นำเสนอ คำอธิบายมีรายละเอียดเพียงพอที่จะช่วยให้ผู้บริโภคประเมินข้อเสนอได้อย่างถูกต้อง หากผู้ประกอบการใช้รูปภาพ ภาพเหล่านั้นจะเป็นภาพที่แท้จริงของผลิตภัณฑ์ บริการ และ/หรือเนื้อหาดิจิทัล ข้อผิดพลาดที่ชัดเจนหรือข้อผิดพลาดในการเสนอที่มีผลผูกพันต่อผู้ประกอบการ
- ข้อเสนอแต่ละข้อจะมีข้อมูลที่ชัดเจนต่อผู้บริโภคว่ามีสิทธิและภาระผูกพันใดบ้างในการยอมรับข้อเสนอนั้นๆ

มาตรา 5 – สัญญา

- ข้อตกลงดังกล่าวต้องเป็นไปตามบทบัญญัติในวรรคที่ 4 ซึ่งสรุปเมื่อผู้บริโภคยอมรับข้อเสนอและปฏิบัติตามเงื่อนไขที่สอดคล้องกัน
- หากผู้บริโภคยอมรับข้อเสนอทางอิเล็กทรอนิกส์ ผู้ประกอบการจะยืนยันการได้รับการยอมรับข้อเสนอทางอิเล็กทรอนิกส์ทันที จนกว่าผู้ประกอบการจะได้รับการยืนยันการตอบรับนี้ ผู้บริโภคสามารถยกเลิกสัญญาได้
- หากข้อตกลงถูกสร้างขึ้นทางอิเล็กทรอนิกส์ ผู้ประกอบการจะต้องใช้มาตรการทางเทคนิคและองค์กรที่เหมาะสมเพื่อปกป้องการถ่ายโอนข้อมูลทางอิเล็กทรอนิกส์ และจะดูแลให้สภาพแวดล้อมทางเว็บมีความปลอดภัย หากผู้บริโภคสามารถชำระเงินทางอิเล็กทรอนิกส์ได้ ผู้ประกอบการจะต้องใช้มาตรการความปลอดภัยที่เหมาะสม
- ผู้ประกอบการสามารถแจ้งให้ผู้บริโภคทราบถึงความสามารถของผู้บริโภคในการปฏิบัติตามภาระผูกพันในการชำระเงิน และข้อเท็จจริงและปัจจัยทั้งหมดที่สำคัญต่อการสรุปสัญญาทางไกลได้ตามกฎหมาย หากผู้ดำเนินการภายใต้การสอบสวนนี้มีเหตุผลในการไม่ทำสัญญา เขาก็มีสิทธิ์ที่จะปฏิเสธหรือผูกมัดการปฏิบัติตามสัญญาให้มีเงื่อนไขพิเศษตามคำสั่งหรือคำขอ
- ผู้ประกอบการจะต้องส่งข้อมูลต่อไปนี้เมื่อทำการจัดส่งผลิตภัณฑ์ บริการ หรือเนื้อหาดิจิทัลให้แก่ผู้บริโภค โดยเป็นลายลักษณ์อักษรหรือในรูปแบบที่ผู้บริโภคสามารถจัดเก็บในสื่อที่ทนทานได้โดยเข้าถึงได้ เพื่อส่ง:
- ที่อยู่สถานประกอบการที่ผู้บริโภคสามารถยื่นเรื่องร้องเรียนได้
- เงื่อนไขและวิธีการที่ผู้บริโภคสามารถใช้สิทธิในการถอน หรือคำชี้แจงที่ชัดเจนเกี่ยวกับการยกเว้นสิทธิในการถอน
- ข้อมูลเกี่ยวกับการรับประกันและบริการหลังการขาย;
- ราคาที่รวมภาษีทั้งหมดของผลิตภัณฑ์ การบริการ หรือเนื้อหาดิจิทัล ในส่วนที่เกี่ยวข้อง ค่าใช้จ่ายในการจัดส่ง และวิธีการชำระเงิน การจัดส่ง หรือการปฏิบัติตามสัญญา
- ข้อกำหนดในการยุติข้อตกลงหากข้อตกลงมีระยะเวลาเกินกว่าหนึ่งปีหรือไม่มีกำหนด
- หากผู้บริโภคมีสิทธิในการถอนตัวและมีแบบฟอร์มการถอนตัวแบบจำลอง

ในกรณีที่มีการทำธุรกรรมแบบขยายเวลา ข้อกำหนดในวรรคก่อนจะใช้กับการจัดส่งครั้งแรกเท่านั้น

มาตรา 6 สิทธิในการถอนตัว

ไม่มีสิทธิในการถอนตัวและไม่มีระยะเวลาพักการตัดสินใจสำหรับสินค้าทุกรายการที่จำหน่ายผ่านเว็บไซต์นี้ ข้อความนี้ระบุไว้ที่นี่ก่อนการสั่งซื้อใด ๆ และใช้กับสินค้าทุกรายการในแคตตาล็อก

เมล็ดพันธุ์กัญชาเป็นสินค้าเกษตรที่บรรจุผนึก เมื่อซองออกจากการดูแลของเราแล้ว ทั้งอัตราการงอกและแหล่งที่มาไม่สามารถตรวจสอบได้ ซึ่งเป็นเหตุผลของข้อยกเว้นนี้

คำสั่งซื้อยังเปลี่ยนแปลงหรือยกเลิกได้ตราบใดที่ยังไม่ได้จัดส่ง ดูมาตรา 19 เมื่อจัดส่งแล้วจะไม่สามารถคืนสินค้าหรือขอคืนเงินได้ ดูมาตรา 20

ข้อความในมาตรานี้ไม่กระทบต่อมาตรา 12 หากสินค้าไม่ตรงตามที่สั่งซื้อหรือเสียหายเมื่อได้รับ กรุณาติดต่อเรา เรื่องนี้เป็นประเด็นความสอดคล้องของสินค้า ไม่ใช่การถอนตัว

มาตรา 7 หน้าที่ของผู้บริโภคในระหว่างการพิจารณา

ไม่มีผลบังคับใช้ ไม่มีระยะเวลาพักการตัดสินใจ ดูมาตรา 6

มาตรา 8 การใช้สิทธิถอนตัวของผู้บริโภคและค่าใช้จ่าย

ไม่มีผลบังคับใช้ ดูมาตรา 6

มาตรา 9 ภาระผูกพันของผู้ประกอบการในกรณีถอนเงิน

ไม่มีผลบังคับใช้ ดูมาตรา 6

มาตรา 10 การยกเว้นสิทธิในการถอนตัว

สินค้าทุกรายการที่จำหน่ายผ่านเว็บไซต์นี้ได้รับการยกเว้นจากสิทธิในการถอนตัวใด ๆ ตามที่ระบุในมาตรา 6

มาตรา 11 – ราคา

- ในระยะเวลาที่กล่าวมา ราคาของผลิตภัณฑ์และ/หรือบริการจะไม่เพิ่มขึ้นตามข้อเสนอ ยกเว้นการเปลี่ยนแปลงราคาอันเนื่องมาจากการเปลี่ยนแปลงอัตราภาษีมูลค่าเพิ่ม
- โดยไม่คำนึงถึงวรรคก่อน ผลิตภัณฑ์หรือบริการทางธุรกิจที่มีราคาขึ้นอยู่กับการผันผวนในตลาดการเงินและผู้ประกอบการไม่สามารถควบคุมได้จะมีราคาที่ผันผวน ความผันผวนเหล่านี้และความจริงที่ว่าเป้าหมายราคาใดๆ ก็ตามก็มีข้อเสนออยู่
- การเพิ่มราคาภายใน 3 เดือนหลังจากการสรุปสัญญาจะได้รับอนุญาตเฉพาะในกรณีที่เป็นผลมาจากกฎหมายหรือข้อบังคับเท่านั้น
- การเพิ่มราคาตั้งแต่ 3 เดือนหลังจากการสรุปสัญญาจะได้รับอนุญาตเฉพาะในกรณีที่ผู้ค้าตกลงและ:

ก. เป็นผลจากกฎหมายหรือระเบียบข้อบังคับ หรือ

ข. ผู้บริโภคมีสิทธิที่จะยกเลิกข้อตกลงได้ตั้งแต่วันที่การปรับขึ้นมีผลบังคับใช้

- ราคาในการจัดหาผลิตภัณฑ์หรือบริการรวมภาษีมูลค่าเพิ่มแล้ว

บทความที่ 12 – ข้อตกลงการปฏิบัติตามและการรับประกันขยายเวลา

- ผู้ประกอบการรับประกันว่าผลิตภัณฑ์และ/หรือบริการเป็นไปตามข้อกำหนดของสัญญาที่ระบุไว้ในข้อเสนอ ความต้องการที่สมเหตุสมผลเกี่ยวกับความน่าเชื่อถือและ/หรือความสามารถในการใช้งาน และในวันที่ทำข้อตกลง จะต้องมีบทบัญญัติทางกฎหมายที่มีอยู่และ/หรือข้อบังคับของรัฐบาล หากตกลงกันแล้ว ผู้ประกอบการจะต้องมั่นใจด้วยว่าผลิตภัณฑ์นั้นเหมาะสมกับการใช้งานอื่นๆ นอกเหนือจากการใช้งานปกติด้วย
- โดยการรับประกันแบบขยายระยะเวลาของผู้ประกอบการค้า ซัพพลายเออร์ ผู้ผลิต หรือผู้นำเข้าจะไม่มีผลใช้บังคับต่อสิทธิตามกฎหมายและการเรียกร้องใดๆ ที่ผู้บริโภคสามารถอ้างได้ภายใต้สัญญากับผู้ประกอบการค้า หากนายจ้างไม่ปฏิบัติตามส่วนหนึ่งของข้อตกลง
- ภายใต้การค้ำประกันเพิ่มเติม หมายความถึงการให้คำมั่นสัญญาใด ๆ โดยผู้ประกอบการ ซัพพลายเออร์ ผู้นำเข้า หรือผู้ผลิต ซึ่งมอบสิทธิหรือข้อเรียกร้องบางประการแก่ผู้บริโภคเกินกว่าที่กฎหมายกำหนดไว้ในกรณีที่ผู้บริโภคไม่ปฏิบัติตามส่วนของตนในข้อตกลง

มาตรา 13 การส่งมอบและการดำเนินการ

- ผู้ประกอบการจะใช้ความระมัดระวังสูงสุดเมื่อรับและดำเนินการตามคำสั่งซื้อผลิตภัณฑ์ และเมื่อประเมินใบสมัครเพื่อการให้บริการ
- สถานที่จัดส่งคือที่อยู่ที่ผู้บริโภคแจ้งให้ผู้ค้าทราบ
- ภายใต้เงื่อนไขและข้อกำหนดที่ระบุไว้ในข้อ 4 บริษัทจะยอมรับคำสั่งซื้ออย่างรวดเร็วแต่ไม่เกิน 30 วัน เว้นแต่จะตกลงระยะเวลาการจัดส่งเป็นอย่างอื่น หากการจัดส่งล่าช้าหรือคำสั่งซื้อไม่ได้รับการดำเนินการหรือดำเนินการเพียงบางส่วน ผู้บริโภคจะได้รับสินค้าภายใน 30 วันหลังจากทำการสั่งซื้อ ผู้บริโภคในกรณีนี้มีสิทธิที่จะยกเลิกสัญญาโดยไม่ต้องลงโทษและมีสิทธิได้รับการชดเชยใด ๆ
- หลังจากการยุบเลิกตามวรรคก่อนแล้ว ผู้ประกอบการจะคืนเงินที่ผู้บริโภคชำระไปทันที
- ความเสี่ยงต่อความเสียหายและ/หรือการสูญเสียสินค้าตกอยู่ที่ผู้ประกอบการจนถึงเวลาส่งมอบสินค้าให้ผู้บริโภคหรือตัวแทนที่ได้รับการแต่งตั้งล่วงหน้าและผู้ประกอบการประกาศ เว้นแต่จะมีข้อตกลงเป็นอย่างอื่นอย่างชัดแจ้ง

มาตรา 14 การทำธุรกรรมระยะเวลาขยาย: ระยะเวลา การยุติ และการต่ออายุ

การสิ้นสุด:

- ผู้บริโภคสามารถทำสัญญาได้ในระยะเวลาไม่กำหนด ซึ่งรวมถึงการส่งมอบผลิตภัณฑ์ (รวมถึงไฟฟ้า) หรือบริการตามปกติ โดยสามารถบอกเลิกกฎการยุติสัญญาที่ใช้บังคับและแจ้งล่วงหน้าได้สูงสุดหนึ่งเดือนได้ตลอดเวลา
- ผู้บริโภคสามารถทำสัญญาที่มีระยะเวลาแน่นอน ซึ่งขยายไปถึงการส่งมอบผลิตภัณฑ์ (รวมถึงไฟฟ้า) หรือบริการตามปกติได้ตลอดเวลาเมื่อสิ้นสุดระยะเวลาที่กำหนด โดยต้องเป็นไปตามกฎการยุติสัญญาที่ตกลงกันไว้และแจ้งให้ทราบล่วงหน้าหนึ่งเดือน
- ผู้บริโภคสามารถปฏิบัติตามข้อตกลงที่กล่าวไว้ในวรรคก่อนหน้านี้ได้:

– ยกเลิกได้ตลอดเวลาและไม่จำกัดเพียงการยุติในเวลาใดเวลาหนึ่งหรือในช่วงระยะเวลาที่กำหนด

– อย่างน้อยก็ยกเลิกแบบเดียวกับที่สรุปไปแล้ว

– ยกเลิกโดยแจ้งล่วงหน้าตามที่บริษัทได้เจรจาไว้เอง

ส่วนขยาย:

- สัญญาที่มีระยะเวลาแน่นอน ซึ่งขยายไปถึงการส่งมอบผลิตภัณฑ์ (รวมถึงไฟฟ้า) หรือบริการตามปกติ อาจจะไม่ได้รับการขยายเวลาหรือต่ออายุโดยอัตโนมัติเป็นระยะเวลาคงที่
- โดยไม่คำนึงถึงวรรคก่อน สัญญาดังกล่าวถือว่าสรุปเป็นระยะเวลาแน่นอน ซึ่งขยายไปถึงการจัดส่งหนังสือพิมพ์และนิตยสารรายวันหรือรายสัปดาห์เป็นประจำ และจะได้รับการต่ออายุโดยปริยายเป็นระยะเวลาคงที่ไม่เกินสามเดือน หากผู้บริโภคสามารถยุติการขยายเวลาตามข้อตกลงที่ขยายออกไปนี้ได้ โดยแจ้งให้ทราบล่วงหน้าไม่เกินหนึ่งเดือน
- สัญญาที่ทำขึ้นเป็นระยะเวลาแน่นอน ซึ่งขยายไปถึงการส่งมอบผลิตภัณฑ์หรือบริการตามปกติ อาจขยายออกไปได้เป็นระยะเวลาไม่แน่นอนเท่านั้น หากผู้บริโภคสามารถยกเลิกสัญญาเมื่อใดก็ได้โดยแจ้งให้ทราบล่วงหน้าไม่เกินหนึ่งเดือน ระยะเวลาแจ้งเตือนเกินกว่า 3 เดือน ในกรณีที่สัญญาขยายไปถึงการส่งหนังสือพิมพ์และนิตยสารรายวัน ข่าวสาร รายสัปดาห์ เป็นปกติแต่ไม่เกินเดือนละครั้ง
- ข้อตกลงที่มีระยะเวลาจำกัดในการจัดส่งวันทดลองใช้ ข่าวสาร และหนังสือพิมพ์และนิตยสารรายสัปดาห์เป็นประจำ (สมัครสมาชิกแบบทดลองใช้หรือแบบแนะนำ) จะสิ้นสุดลงโดยอัตโนมัติและไม่สามารถต่ออายุโดยปริยายได้หลังจากสิ้นสุดการทดลองใช้หรือแบบแนะนำ

ระยะเวลา:

- หากสัญญามีระยะเวลามากกว่าหนึ่งปี ผู้บริโภคอาจถอนตัวหรือบอกเลิกสัญญาได้ตลอดเวลาหลังจากผ่านไปหนึ่งปี โดยต้องแจ้งให้ทราบล่วงหน้าไม่เกินหนึ่งเดือน เว้นแต่จะมีความสมเหตุสมผลและยุติธรรมต่อการบอกเลิกสัญญา ก่อนสิ้นสุดระยะเวลาตามที่ตกลงกันไว้

มาตรา 15 – การชำระเงิน

- เว้นแต่จะระบุไว้เป็นอย่างอื่นในสัญญาหรือมีเงื่อนไขเพิ่มเติมหากจำนวนเงินที่ผู้บริโภคต้องชำระภายใน 14 วันหลังจากการเริ่มต้นของระยะเวลาพักการขาย หรือในกรณีที่ไม่มีระยะเวลาพักการขายภายใน 14 วันหลังจากการสรุปข้อตกลง กรณีมีการตกลงให้บริการ ระยะเวลาดังกล่าวจะเริ่มนับในวันถัดจากวันที่ผู้บริโภคได้รับการยืนยันการตกลง
- เมื่อมีการขายสินค้าให้แก่ผู้บริโภค โดยทั่วไปแล้ว ผู้บริโภคจะไม่จำเป็นต้องชำระเงินล่วงหน้าเกินกว่า 50% หากมีการตกลงชำระเงิน ผู้บริโภคจะไม่สามารถยืนยันสิทธิใดๆ เกี่ยวกับการดำเนินการตามคำสั่งซื้อหรือบริการ ก่อนที่จะมีการชำระเงินล่วงหน้า
- ผู้บริโภคมีหน้าที่รับผิดชอบในความผิดพลาดของข้อมูลที่ให้มาหรือการชำระเงินที่ระบุไว้ให้กับผู้ประกอบการทันที

มาตรา 16 การร้องเรียน

- ผู้ประกอบการมีการร้องเรียนที่เป็นสาธารณะอย่างดีและจัดการกับการร้องเรียนภายใต้ขั้นตอนนี้
- การร้องเรียนเกี่ยวกับการปฏิบัติตามสัญญาต้องได้รับการอธิบายอย่างครบถ้วนและชัดเจนและส่งให้ผู้ประกอบการภายในระยะเวลาอันสมเหตุสมผลหลังจากที่ผู้บริโภคได้รับข้อบกพร่อง
- เมื่อผู้ประกอบการร้องเรียนภายในระยะเวลา 14 วัน นับจากวันที่ได้รับคำร้องเรียน หากคาดว่าการร้องเรียนจะใช้เวลาในการดำเนินการนานกว่าปกติ เจ้าหน้าที่จะตอบกลับภายในระยะเวลา 14 วัน พร้อมทั้งแจ้งการรับเรื่อง และแจ้งให้ทราบว่าผู้บริโภคสามารถคาดหวังคำตอบที่ละเอียดกว่านี้ได้หรือไม่
- ถ้าข้อร้องเรียนหรือภายในระยะเวลาอันสมเหตุสมผลหรือภายในสามเดือนหลังจากการยื่นข้อร้องเรียนสามารถแก้ไขได้โดยข้อตกลงร่วมกันก่อให้เกิดข้อโต้แย้งที่เป็นเหตุให้เกิดข้อโต้แย้งได้

มาตรา 17 – ข้อพิพาท

- ข้อตกลงระหว่างผู้ประกอบการและผู้บริโภคนั้นให้ยึดตามกฎหมายไทยเท่านั้น

บทความที่ 18 – นโยบายการจัดส่ง

จัดส่งเฉพาะภายในประเทศไทย คำสั่งซื้อที่ทำก่อน 15.00 น. ในวันทำการจะถูกจัดส่งในวันเดียวกัน การจัดส่งทางไปรษณีย์แบบมาตรฐานมีค่าบริการ 100 บาท ทั่วประเทศไทยรวมถึงกรุงเทพฯ และโดยปกติจะได้รับภายใน 1 ถึง 3 วันทำการ สำหรับในเขตกรุงเทพฯ มีบริการจัดส่งภายในวันเดียวเป็นตัวเลือกเพิ่มเติมในราคา 250 บาท

บทความที่ 19 – นโยบายการยกเลิก

คำสั่งซื้อสามารถเปลี่ยนแปลงหรือยกเลิกได้ตราบใดที่ยังไม่ได้จัดส่ง กรุณาติดต่อเราพร้อมแจ้งหมายเลขคำสั่งซื้อโดยเร็วที่สุด เนื่องจากคำสั่งซื้อที่ทำก่อน 15.00 น. ในวันทำการจะถูกจัดส่งในวันเดียวกัน ช่วงเวลาที่ยกเลิกได้จึงสั้น เมื่อจัดส่งแล้วจะไม่สามารถยกเลิกได้

บทความที่ 20 – นโยบายการคืนสินค้าและการคืนเงิน

สินค้าที่ซื้อผ่านเว็บไซต์นี้ไม่สามารถส่งคืนได้ และไม่มีการคืนเงินสำหรับสินค้าที่ส่งคืน มาตรา 6 ยกเว้นสิทธิในการถอนตัวทั้งหมด ส่วนมาตรา 19 ว่าด้วยการเปลี่ยนแปลงหรือยกเลิกคำสั่งซื้อก่อนการจัดส่ง ข้อความนี้ไม่กระทบต่อมาตรา 12 หากสินค้าไม่ตรงตามที่สั่งซื้อหรือเสียหายเมื่อได้รับ กรุณาติดต่อเรา

ข้อ 21 – ข้อกำหนดเพิ่มเติมหรือแตกต่างกัน

ข้อกำหนดเพิ่มเติมหรือแตกต่างไปจากข้อกำหนดเหล่านี้อาจไม่ก่อให้เกิดความเสียหายต่อผู้บริโภค และควรได้รับการบันทึกเป็นลายลักษณ์อักษรหรืออาจทำในลักษณะที่ผู้บริโภคสามารถจัดเก็บในสื่อที่ทนทานในลักษณะที่เข้าถึงได้

ไม่อนุญาตให้จัดส่งระหว่างประเทศ
